import { render, staticRenderFns } from "./InhemeterElectricMeter.vue?vue&type=template&id=483fe60e&scoped=true&"
import script from "./InhemeterElectricMeter.vue?vue&type=script&lang=js&"
export * from "./InhemeterElectricMeter.vue?vue&type=script&lang=js&"
import style0 from "./InhemeterElectricMeter.vue?vue&type=style&index=0&id=483fe60e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483fe60e",
  null
  
)

export default component.exports